<script>
import Input from "@/components/c-input";

/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: {
    Input,
  },
  data() {
    return {

      valueName: '',
      valuePosition: '',
      valueShare: 0,
      valueInvestment: 0,
      valuePaid: 0,
      valueBalance: 0,

      valuePay: 0

    };
  },
  watch: {
      valuePay: function() { // watch it
        // console.log(newVal);
        this.changePaid();
      }
  },
  mounted() {

    if(this.item != null) {
      this.valueName = this.item.name;
      this.valuePosition = this.item.position;
      this.valueShare = this.item.share;
      this.valueInvestment = this.item.invest_share;
      this.valuePaid = this.item.paid;
      this.valueBalance = this.item.invest_share - this.valuePaid;
    }
  },
  methods: {

    changePaid: function() {
      this.valueBalance = this.valueInvestment - this.valuePaid - this.valuePay;
    },
    
    getPayValue: function() {
      return this.valuePay;
    },
    
    formatCurrency(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '$';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

    },
  },
  props: {
    item: null,

    index: {
      type: Number,
      default: 0
    },

  },
};
</script>
<template>
  <div class="row">
    <div class="col-md-3" style="padding-top: 20px;">
      <p class="h4">{{valueName}}</p>
      <p class="h7">{{valuePosition}}</p>
      <p class="h4">{{valueShare}}%</p>
      <p class="h6">{{formatCurrency(valueInvestment)}}</p>
    </div>
    <div class="col-md-3" style="padding-top: 20px;">
      <Input 
          :type="`number`"
          :id="`paid${index}`"
          :disabled="true"
          v-model="valuePaid"
          :last="'USD'"
          :label="'stock-owner.paid'"  />
    </div>
    <div class="col-md-3" style="padding-top: 20px;">
      <Input 
          :type="'number'"
          :id="`pay${index}`"
          v-model="valuePay"
          :last="'USD'"
          :label="'stock-owner.more.received-payment'"  />
    </div>
    <div class="col-md-3" style="padding-top: 20px;">
      <Input 
          :type="'number'"
          :id="`balance${index}`"
          :disabled="true"
          v-model="valueBalance"
          :last="'USD'"
          :label="'stock-owner.balance'"  />
    </div>
  </div>
</template>